<template>
  <div class="why-eboX">
    <div :class="['why-eboX-is-img-wrap',{'why-eboX-is-img-wrap-color':isHome}]">
      <img class="why-eboX-is-img" src="https://mediakit.enabot.com/eboX/img/mobile/what_eboX_is@2x.png" alt="">
    </div>
    <div class="why-eboX-content">
      <!-- <img class="what-eboX-is-bg" src="https://mediakit.enabot.com/eboX/img/mobile/Three_Home_Devices_bg.png" alt=""> -->
      <div>
        <img class="Three-Home-Devices" src="https://mediakit.enabot.com/eboX/img/mobile/Three_Home_Devices@2x.png" alt="">
      </div>
      <div class="what-eboX-is-bg-box">
        <img class="what-eboX-is-bg" src="https://mediakit.enabot.com/eboX/img/mobile/Three_Home_Devices_bg@2x.png" alt="">
        <div class="A-Moving-Homebot-box">
          <h3 class="A-Moving-Homebot-box-title font-15-rem-title">A Moving Homebot</h3>
          <p class="A-Moving-Homebot-box-des font-12-rem">with Built-in Alexa&V-SLAM Navigation</p>
        </div>
        <div class="A-Premium-Speaker-box">
          <h3 class="A-Premium-Speaker-box-title font-15-rem-title">A Premium Speaker</h3>
          <p class="A-Premium-Speaker-box-des font-12-rem">with Harman AudioEFX</p>
        </div>
        <div class="A-4K-Stablized-Camera-box">
          <h3 class="A-4K-Stablized-Camera-box-title font-15-rem-title">A 4K Stabilized Camera</h3>
          <p class="A-4K-Stablized-Camera-box-des font-12-rem">with Color Night Vision</p>
        </div>
      </div>
      <div class="Three-in-One-Home-Guardian-box">
        <img class="Three-in-One-Home-Guardian-img" src="https://mediakit.enabot.com/eboX/img/mobile/Three_in_One_Home_Guardian@2x.png" alt="">
      </div>
      <div class="Guardian-img-box">
        <div
          v-lazy-container="{ selector: 'img', 
          error: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png', 
          loading: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png'}"
          class="Guardian-img-wrap">
          <img data-src="https://mediakit.enabot.com/eboX/img/mobile/Three_in_One_Home_Guardian1@2x.png" alt="">
          <div class="Guardian-img-box-text font-12-rem">Your Family's Protector</div>
        </div>
        <div
          v-lazy-container="{ selector: 'img', 
          error: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png', 
          loading: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png'}" 
          class="Guardian-img-wrap">
          <img data-src="https://mediakit.enabot.com/eboX/img/mobile/Three_in_One_Home_Guardian2@2x.png" alt="">
          <div class="Guardian-img-box-text font-12-rem">
            Your Family's Companion
          </div>
        </div>
        <div
          v-lazy-container="{ selector: 'img', 
          error: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png', 
          loading: 'https://mediakit.enabot.com/eboX/img/common/phone_ebabot110_180.png'}"
          class="Guardian-img-wrap">
          <img data-src="https://mediakit.enabot.com/eboX/img/mobile/Three_in_One_Home_Guardian3@2x.png" alt="">
          <div class="Guardian-img-box-text font-12-rem">
            Your Family's Playmate
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:['isHome']
}
</script>

<style lang="scss" scoped>
.why-eboX{
  width: 100%;
  .why-eboX-is-img-wrap{
    // background: RGBA(8, 20, 72, 1);
    text-align: center;
    margin-bottom: 2.5rem;
  }
  .why-eboX-is-img-wrap-color{
    background: RGBA(8, 20, 72, 1);
  }
  .why-eboX-is-img{
    width: 94%;
    height: auto;
    margin: 0 auto;
  }
  .why-eboX-content{
    width: 94%;
    height: auto;
    margin: 0 auto;
    position: relative;
    background-color: rgba(3, 3, 10, 1);
    border-radius: 0.25rem;
  }
  .Three-Home-Devices{
    padding: 1.375rem 0 1.75rem 0;
    width: 55%;
    height: auto;
    margin: 0 auto;
  }
  .what-eboX-is-bg-box{
    width: 100%;
    height: auto;
    position: relative;
  }
  .what-eboX-is-bg{
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
  
  .A-Moving-Homebot-box{
    position: absolute;
    top: 3rem;
    left: 1.25rem;
    width: 100%;
    height: auto;
    text-align: left;
  }
  .A-Premium-Speaker-box{
    position: absolute;
    top: 9.8rem;
    right: 1.25rem;
    width: 100%;
    height: auto;
    text-align: right;
  }
  .A-4K-Stablized-Camera-box{
    position: absolute;
    top: 16.4rem;
    left: 1.25rem;
    width: 100%;
    height: auto;
    text-align: left;
  }
  .A-Moving-Homebot-box-title,.A-Premium-Speaker-box-title,.A-4K-Stablized-Camera-box-title{
    margin-bottom: 0.48rem;
  }
  .A-Moving-Homebot-box-des,.A-Premium-Speaker-box-des,.A-4K-Stablized-Camera-box-des{
    transform: scale(0.86);
    opacity: 0.7;
  }
  .A-Premium-Speaker-box-des{
    margin-right: -1.7rem;
  }
  .A-Moving-Homebot-box-des,.A-4K-Stablized-Camera-box-des{
    margin-left: -1.7rem;
  }
  .Three-in-One-Home-Guardian-box{
    width: 78%;
    height: auto;
    margin: 0 auto;
    padding: 2.25rem 0 1.875rem 0;
  }
  .Guardian-img-box{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 0.625rem;
    .Guardian-img-wrap{
      position: relative;
      width: 30%;
    }
    img{
      width: 100%;
    }
    .Guardian-img-wrap:nth-child(2){
      margin: 0 2%;
    }
    .Guardian-img-box-text{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.75rem;
      width: 80%;
      opacity: 0.7;
    }
  }
}
</style>